module.exports = __webpack_public_path__ + "static/media/20.657dd414.jpg";